import { GridHelper } from 'components/Grids/GridHelper';
import {
  GeneralCellRenderer,
  BatchFormActionsCellRenderer,
  CustomerLinkCellRenderer,
  AccountLinkCellRenderer
} from 'components/Grids/CellRenderers';

export default class BatchFormsColumnDefinitions {
  static createColDefs() {
    const columnDefs = [
      {
        headerName: 'Shareholder ID',
        cellClass: 'center-aligned',
        field: 'customerId',
        cellRenderer: CustomerLinkCellRenderer,
        minWidth: 150,
        width: 170,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'Line One Name',
        field: 'entityName',
        cellRenderer: GeneralCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'Account',
        field: 'accountNumber',
        cellRenderer: AccountLinkCellRenderer,
        minWidth: 130,
        width: 150,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'Shareholder Country',
        field: 'customerPermanentAddressCountry',
        cellRenderer: GeneralCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'Legal Entity',
        field: 'legalEntity',
        cellRenderer: GeneralCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'Form Type',
        field: 'formTypeDescription',
        cellRenderer: GeneralCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'Form Validity',
        field: 'valid',
        cellClass: 'center-aligned',
        cellRenderer: GeneralCellRenderer,
        valueGetter: ({
          data: { valid }
        }) => {
          if (valid === null || valid === 'undefined') {
            return 'Not Validated';
          }
          return valid ? 'Valid' : 'Rejected';
        },
        minWidth: 70,
        width: 120,
        filter: 'text',
        filterParams: { apply: true }
      },
      { headerName: 'Workflow Status',
        field: 'workflowStatus',
        cellRenderer: GeneralCellRenderer,
        minWidth: 120,
        width: 120,
        filter: 'text'
      },
      {
        headerName: 'Original File Name',
        field: 'originalFileName',
        cellRenderer: GeneralCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'Upload Date',
        field: 'dateUploaded',
        cellRenderer: GeneralCellRenderer,
        valueGetter: ({
          data: { dateUploaded }
        }) => GridHelper.dateFormatter(dateUploaded, 'MMM DD, YYYY HH:mm:ss'),
        minWidth: 95,
        width: 145,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'View / Action',
        cellClass: 'center-aligned form-action-btns',
        field: 'id',
        cellRenderer: BatchFormActionsCellRenderer,
        minWidth: 70,
        width: 115,
        filter: false
      }
    ];

    return columnDefs;
  }
}
